import { useState, useEffect } from 'react';
import api from '../../utils/api';

const PLAN_COLORS = {
  trial: '#f59e0b', TRIAL: '#f59e0b',
  starter: '#3b82f6', STARTER: '#3b82f6',
  pro: '#10b981', PRO: '#10b981',
};

export default function AdminDaily() {
  const today = new Date().toISOString().split('T')[0];
  const [date, setDate] = useState(today);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = (d) => {
    setLoading(true);
    api.get(`/admin/daily?date=${d}`)
      .then(r => setData(r))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(today); }, []);

  const handleDateChange = (e) => {
    setDate(e.target.value);
    load(e.target.value);
  };

  const rows = data?.rows || [];
  const totalMessages = rows.reduce((s, r) => s + r.messageCount, 0);
  const totalRes = rows.reduce((s, r) => s + r.reservationCount, 0);
  const totalConv = rows.reduce((s, r) => s + r.conversationCount, 0);

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>Günlük Rapor</h1>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>Otel bazında günlük kullanım istatistikleri</p>

      {/* Date picker */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <label style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>Tarih:</label>
        <input
          type="date"
          value={date}
          max={today}
          onChange={handleDateChange}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, background: 'white' }}
        />
        <span style={{ fontSize: 13, color: '#94a3b8' }}>
          {date === today ? '(bugün — canlı veri)' : '(geçmiş — kayıtlı veri)'}
        </span>
      </div>

      {/* Summary */}
      {data && (
        <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
          {[
            { label: 'Toplam Mesaj', value: totalMessages, color: '#6366f1' },
            { label: 'Toplam Konuşma', value: totalConv, color: '#3b82f6' },
            { label: 'Toplam Rezervasyon', value: totalRes, color: '#10b981' },
          ].map(s => (
            <div key={s.label} style={{
              flex: 1, background: 'white', borderRadius: 10, padding: '16px 20px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderTop: `3px solid ${s.color}`,
            }}>
              <div style={{ fontSize: 26, fontWeight: 800, color: '#0f172a' }}>{s.value}</div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Table */}
      <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Yükleniyor...</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['Otel', 'Plan', 'Mesaj', 'Konuşma', 'Rezervasyon', 'Takeover'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 12, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.hotelId}>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontWeight: 600, color: '#1e293b' }}>{r.hotelName}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9' }}>
                    <span style={{
                      fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 20,
                      color: 'white',
                      background: PLAN_COLORS[r.plan] || '#94a3b8',
                    }}>{r.plan}</span>
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontWeight: 600, color: '#475569' }}>{r.messageCount}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontWeight: 600, color: '#475569' }}>{r.conversationCount}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontWeight: 600, color: '#475569' }}>{r.reservationCount}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', color: '#94a3b8' }}>{r.takeoverCount}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr>
                  <td colSpan={6} style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>
                    Bu tarih için veri bulunamadı.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
